import { HOST_QUERY_KEY, metaApiInstance, type ServiceAppState } from '@kc-console/context';
import { STATUS_CODE } from '@kc-console/core';

import { commonGuardErrorHandler } from '../../utils/commonGuardErrorHandler';
import { getServerTraceHttpTimingOptions } from '../../utils/serverTrace/store';

import type { Guard } from '../../types';

/**
 * 즐겨찾는 서비스를 얻는 가드입니다.
 * @description
 * - 스코프가 project인 경우 프로젝트 내에서 즐겨찾는 서비스
 * - 그 외의 스코프에 대해서는 도메인 기준의 즐겨찾는 서비스
 * - GNB속의 MegaMenu의 UI를 구성하기 위해 필요합니다.
 */
export const determineFavoriteServiceGuard: Guard<ServiceAppState> = async ({
  state,
  context,
  queryClient,
}) => {
  const { token = '' } = state;
  const { fetchFavoriteService } = metaApiInstance({
    token,
    ...getServerTraceHttpTimingOptions(context.req, 'config'),
  });

  try {
    await queryClient.fetchQuery({
      queryKey: [HOST_QUERY_KEY.GET_FAVORITE_SERVICE],
      queryFn: () => fetchFavoriteService(),
    });

    return { status: STATUS_CODE.OK };
  } catch (error) {
    return commonGuardErrorHandler({ error, context, state });
  }
};

determineFavoriteServiceGuard.displayName = 'determineFavoriteServiceGuard';
